/**
 * ChatPage — /tutorials  (Video Tutorials)
 *
 * Tutorial tree with per-series grouping. Live human support has moved to
 * /support/tickets (Chatwoot) — this page is video-only.
 *
 * When navigated with location.state = { tutorialId: "06" } (from
 * PageHelpBubble) the relevant tutorial is highlighted + scrolled into view.
 */

import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import TutorialTree from "../../components/tutorials/TutorialTree";
import TutorialPlayer from "../../components/tutorials/TutorialPlayer";

export default function ChatPage() {
  const location = useLocation();
  const [highlightTutorial, setHighlightTutorial] = useState(location.state?.tutorialId || null);
  const [playingTutorial, setPlayingTutorial] = useState(null);

  /* clear highlight a few seconds after landing here from PageHelpBubble */
  useEffect(() => {
    if (!highlightTutorial) return;
    const t = setTimeout(() => setHighlightTutorial(null), 4000);
    return () => clearTimeout(t);
  }, [highlightTutorial]);

  return (
    <div style={{
      minHeight: "calc(100vh - 60px)",
      background: "#f7f8fc",
      overflowY: "auto",
    }}>
      <TutorialTree highlightId={highlightTutorial} onPlay={setPlayingTutorial} />

      {playingTutorial && (
        <TutorialPlayer
          tutorial={playingTutorial}
          onClose={() => setPlayingTutorial(null)}
        />
      )}
    </div>
  );
}
